import React, { useState, useEffect } from "react";
import { API_URL } from "../constants";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

export default function ChangeTypeForm({ id, rafraichir, token }) {
  const [newuser, setNewuser] = useState({ type: "" });
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`${API_URL}/users/${id}`, {
          headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: "Bearer " + token }
        });
        setNewuser({ type: response.data.type || "" });
        setTwoFactorEnabled(response.data.twoFactorEnabled || false);
      } catch (error) {
        if (error.response?.status === 401) {
          alert("ERREUR : Votre session a expiré. Veuillez vous reconnecter.");
          localStorage.clear();
          navigate("/login");
        }
      }
    };
    fetchUser();
  }, [id, token, navigate]);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleChange = (event) => {
    setNewuser({ ...newuser, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios.patch(
        `${API_URL}/users/${id}`,
        { type: newuser.type },
        { headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: "Bearer " + token } }
      );
      setIsError(false);
      setMessage("Niveau d'accès modifié avec succès !");
      rafraichir();
      window.location.reload();
    } catch (error) {
      setIsError(true);
      setMessage("Échec de la mise à jour.");
    }
  };

  const toggleTwoFactorAuth = async () => {
    const endpoint = twoFactorEnabled ? `/users/${id}/disable-2fa` : `/users/${id}/enable-2fa`;
    try {
      await axios.post(`${API_URL}${endpoint}`, {}, {
        headers: { Authorization: "Bearer " + token }
      });
      setTwoFactorEnabled(!twoFactorEnabled);
      setIsError(false);
      setMessage(`Double authentification ${!twoFactorEnabled ? "activée" : "désactivée"} !`);
    } catch (error) {
      setIsError(true);
      setMessage("Erreur lors de la modification du 2FA.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-3">
      <select
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
        onChange={handleChange}
        value={newuser.type}
        name="type"
      >
        <option value="">Nouveau niveau d'accès</option>
        <option value="0">SuperAdmin</option>
        <option value="1">Admin</option>
        <option value="2">Chef d'agence</option>
        <option value="3">Chef d'atelier</option>
        <option value="4">Capteur</option>
      </select>

      <input
        type="submit"
        value="Mettre à jour"
        className="w-full bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold py-2.5 rounded-xl transition-all duration-200 cursor-pointer border-none"
      />

      {/* Toggle 2FA */}
      <label className="flex items-center gap-3 mt-1 cursor-pointer select-none">
        <div
          onClick={toggleTwoFactorAuth}
          className={`relative w-10 h-6 rounded-full transition-colors duration-200 cursor-pointer shrink-0
            ${twoFactorEnabled ? 'bg-loginBordure' : 'bg-gray-200'}`}
        >
          <span className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow transition-transform duration-200
            ${twoFactorEnabled ? 'translate-x-5' : 'translate-x-1'}`}
          />
        </div>
        <span className="text-sm text-gray-600">
          {twoFactorEnabled ? "Désactiver" : "Activer"} la double authentification (2FA)
        </span>
      </label>

      {message && (
        <div className={`flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium
          ${isError ? 'bg-red-50 border border-red-200 text-red-700' : 'bg-emerald-50 border border-emerald-200 text-emerald-700'}`}>
          <span className={`w-2 h-2 rounded-full shrink-0 ${isError ? 'bg-red-500' : 'bg-emerald-500'}`} />
          {message}
        </div>
      )}
    </form>
  );
}